import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PageContainer } from "shared";
import WalletDrawer from "./WalletDrawer";
import WalletContent from "./WalletContent";
import WalletContentMobile from "./WalletContentMobile";
import {
  useUserCryptoPending,
  useWalletStatus,
  useGetCryptoTransAuth,
} from "api";
import TopContent from "./components/TopContent";
import { classNames, useBreakpoint } from "utils";

export default function Index() {
  const breakpoint = useBreakpoint();

  const { currentId } = useLocation().state || {};

  const [setWalletStatus] = useWalletStatus();

  useEffect(() => {
    if (currentId) {
      setWalletStatus({ currentWallet: currentId });
    }
  }, [currentId]);

  useUserCryptoPending();
  useGetCryptoTransAuth();

  return (
    <PageContainer header="Crypto Wallets">
      <TopContent />
      <div
        className={classNames(
          "relative overflow-hidden rounded-xl bg-white shadow-md",
          breakpoint.md ? "h-[480px]" : "h-[400px]"
        )}
      >
        <div className="flex flex-row overflow-hidden rounded-xl">
          <WalletDrawer />
          {breakpoint.md && <WalletContent />}
        </div>
        {!breakpoint.md && <WalletContentMobile />}
      </div>
    </PageContainer>
  );
}
